import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';


export const TableCellWhite = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    borderTop: "1px solid #dddddd",
    fontWeight: "600",
  },
  body: {
    fontSize: 12,

  },
}))(TableCell);